import { gql } from "@apollo/client";

export const GENERATE_DISCORD_TOKEN = gql`
  mutation GenerateDiscordToken($discordId: String!) {
    generateDiscordToken(discordId: $discordId)
  }
`;
export const VALIDATE_DISCORD_TOKEN = gql`
  mutation ValidateDiscordToken($input: validateDiscordIdInput) {
    validateDiscordToken(input: $input)
  }
`;
